import React, { PureComponent, useMemo } from 'react'
import { TableCell, TextField, Input as MaterialInput } from '@material-ui/core'
import { Field } from 'redux-form'

import { CURRENCY_RATE_ZL, CURRENCY_RATE_CZK } from 'constants/config'
import { priceMaker } from 'services/helpers'

const Input = ({ input, label, initialvalue, ...custom }) => (
  <MaterialInput
    label={label}
    style={{ fontSize: '0.845rem', width: 100 }}
    {...input}
    {...custom}
  />
)

export class BookingTableCellBase extends PureComponent {
  renderMainCity = city => (
    <option key={city.id} value={city.label}>
      {city.label.slice(0, 10)}
    </option>
  )

  renderPlace = place => (
    <option
      key={place}
      value={place}
      disabled={this.props.bookedPlaces.includes(`${place}`)}
    >
      {place}
    </option>
  )

  renderDropdownField = (label, value, options, onChange, renderOption) => (
    <TextField
      select
      name={label}
      value={value || ''}
      onChange={onChange}
      InputProps={{
        style: { fontSize: 'inherit' }
      }}
      SelectProps={{
        native: true
      }}
    >
      <option value='' />
      {options.map(renderOption)}
    </TextField>
  )

  onSystemCityChange = e => {
    const { setSystemCity, id } = this.props

    const field = e.target.name
    const value = e.target.value

    setSystemCity({ id, field, value })
  }

  checkSourceId = ({ value, paidStatus, currency, discount, sourceId }) => {
    let newValue = value;
    if (sourceId === 'new_website') {
      if (currency === 'zl') {
        newValue = newValue / CURRENCY_RATE_ZL;
      } else if (currency === 'czk') {
        newValue = newValue / CURRENCY_RATE_CZK;
      }
    }

    return `${priceMaker(newValue, paidStatus, discount)} ${currency}`
  }

  onPlaceChange = prevValue => e => {
    const { id, setPassengerPlace } = this.props

    const value = e.target.value

    setPassengerPlace({ id, value, prevValue })
  }

  renderValue = (data) => {
    const { isEditing, mainCities, places } = this.props
    const { label, value, source } = data

    /* eslint-disable */
    switch (true) {
      case isEditing:
        return (
          <Field
            name={label}
            component={Input}
          />
        )
      case label === 'price':
        return data.source === 'system'
          ? (
            <del>
              {this.checkSourceId(data)}
            </del>
          )
          : this.checkSourceId(data)
      case label === 'place':
        return this.renderDropdownField(label, value, places, this.onPlaceChange(value), this.renderPlace)
      case source === 'system':
        return this.renderDropdownField(label, value, mainCities, this.onSystemCityChange, this.renderMainCity)
      case label === 'from' || label === 'to':
        return value.slice(0, 10)
      default:
        return value
    }
    /* eslint-enable */
  }

  render() {
    const { classes, data } = this.props

    return (
      <TableCell padding='none' className={classes.tableCell}>
        {this.renderValue(data)}
      </TableCell>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Bookings/components/BookingTableCell/BookingTableCell.js